import React from 'react';
import { Dialog, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Close } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    paper: {
        maxWidth: '100%',
        width: '888px',
        borderRadius: '6px',
        maxHeight: '644px',
        height: '100%',
    },
    close: {
        background: '#ffffff !important',
        width: '36px !important',
        height: '36px !important',
        color: '#f78427 !important',
        position: 'fixed !important',
        margin: '-36px !important',

        '@media (max-width: 850px)': {
            margin: '-20px !important',
        },
        '&:hover': {
            backgroundColor: '#ffffff !important',
        },
    },
    highlightImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
}));

const ModalImageFullScreen = ({
    img = '/static/images/default.png',
    open = false,
    onClose = () => {},
    style = {},
}) => {
    const classes = useStyles();
    return (
        <div>
            <Dialog
                classes={{ paperWidthSm: classes.paper }}
                open={open}
                onClose={onClose}
            >
                <IconButton className={classes.close} onClick={onClose}>
                    <Close style={{ fontSize: '20px' }} />
                </IconButton>
                <img
                    className={classes.highlightImage}
                    src={img}
                    style={style}
                    alt=""
                />
            </Dialog>
        </div>
    );
};

export default ModalImageFullScreen;
